module.exports = __webpack_public_path__ + "static/media/iphone_wires.6e22b069.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brite/iphone_wires.png
// module id = 280
// module chunks = 0